import { useGetViewupSnsAccounts } from 'Shared/hooks/api';
import { Analytics } from 'Shared/utils/client';
import { LINK } from '@constants';
import { useGlobalModalStore } from 'app/_hook';
import { useRouter } from 'next/navigation';
import { AccountMenuButton } from '../OffViewingButton';

export const ViewingCampaignButton = () => {
  const router = useRouter();

  const { data: getViewingAccounts } = useGetViewupSnsAccounts();
  const hasViewingAccount = (getViewingAccounts?.data.length || 0) > 0;

  const { getValue } = useGlobalModalStore();
  const { setAlertModal } = getValue('actions');

  const handleClickThis = () => {
    Analytics.getInstance().track('VIEWING_OFF_MENU', { type: 'viewing' });
    if (hasViewingAccount) {
      router.push(LINK.ACCOUNT_SETTINGS);
      return;
    }

    setAlertModal({
      actionButtonText: '계정 추가하기',
      content: `보너스뷰업으로 설정할 수 있는\n계정이 없어요.`,
      onClickActionButton: () => {
        router.push(LINK.ACCOUNT_ADD);
      },
      title: '계정을 추가해 주세요.',
    });
  };

  return (
    <AccountMenuButton
      content={`더 많은 뷰업 캠페인을 만나고 싶다면?`}
      onClick={handleClickThis}
      title={'뷰업 보너스 활동'}
    />
  );
};
